type StripeSyncBannerAgent = {
	lastSyncedAt?: Date | string | null;
	verificationProvider?: string | null;
	verificationStatus?: string | null;
};

export function getStaleStripeSync(
	agent: StripeSyncBannerAgent,
): { lastSyncedAt: Date | string } | null {
	if (agent.verificationProvider !== "stripe") {
		return null;
	}

	if (agent.verificationStatus !== "failed") {
		return null;
	}

	if (!agent.lastSyncedAt) {
		return null;
	}

	return {
		lastSyncedAt: agent.lastSyncedAt,
	};
}

export function getStaleRevenueSync(
	agent: StripeSyncBannerAgent,
): { lastSyncedAt: Date | string; provider: string | null } | null {
	if (!agent.verificationProvider) {
		return null;
	}

	if (agent.verificationStatus !== "failed") {
		return null;
	}

	if (!agent.lastSyncedAt) {
		return null;
	}

	return {
		lastSyncedAt: agent.lastSyncedAt,
		provider: agent.verificationProvider,
	};
}
